// Vendor libraries
import { ChangeDetectorRef, EventEmitter } from '@angular/core';
// Constants
import { DEFAULT_SECURITY_GROUP_TAB_OPTIONS } from 'SecurityListsApp/ts/features/security-list-selector-modals/constants';
// Services
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import { SecurityListMenuService } from 'SecurityListsApp/ts/services/security-list-menu.service';
// Directives
import { AutocompleteInPlaceDirective } from '../autocomplete-in-place.directive';
import * as i0 from "@angular/core";
import * as i1 from "SecuritiesApp/ts/services/securities.service";
import * as i2 from "SecurityListsApp/ts/services/security-list-menu.service";
import * as i3 from "../../base-autocomplete/components/base-autocomplete.component";
import * as i4 from "../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i5 from "@angular/common";
import * as i6 from "../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i7 from "../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i8 from "../../../../../../../security_lists/static/security_lists/ts/features/security-list-selector-modals/security-list-selector-modal/security-list-selector-modal.component";
const _c0 = a0 => ({ "is-editing": a0 });
function SecurityAndListAutocompleteInPlaceComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r1.errorMessage, i0.ɵɵsanitizeHtml);
} }
function SecurityAndListAutocompleteInPlaceComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 12)(1, "a", 13);
    i0.ɵɵlistener("click", function SecurityAndListAutocompleteInPlaceComponent_span_10_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.cancel()); });
    i0.ɵɵtext(2, " Cancel ");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r1.displayValue);
} }
function SecurityAndListAutocompleteInPlaceComponent_span_11_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 12)(1, "a", 14);
    i0.ɵɵlistener("mouseenter", function SecurityAndListAutocompleteInPlaceComponent_span_11_Template_a_mouseenter_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.shouldBlur = false); })("mouseleave", function SecurityAndListAutocompleteInPlaceComponent_span_11_Template_a_mouseleave_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.shouldBlur = true); })("click", function SecurityAndListAutocompleteInPlaceComponent_span_11_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r4); i0.ɵɵnextContext(); const securityListSelectorModal_r5 = i0.ɵɵreference(13); return i0.ɵɵresetView(securityListSelectorModal_r5.openModal()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", "list");
} }
/**
 *
 * Security and List Autocomplete In Place Component
 *
 * Most of the logic is handled by the abstract base class `AutocompleteInPlaceDirective`, please see for
 * further documentation.
 *
 * Input Properties:
 *  allowSecurityLists: whether security lists should be selectable in the component.
 *  displayIdentifier: the security symbol or security list name used to fetch the display name.
 *  securityListGroup: the security group of the currently selected security list, if any.
 *  securityListGroupOptions: list of security group tabs to display in the security list selector modal.
 *  errorMessage: error message for current security
 *  disableEditBtn: disable security edit button
 *
 * Output Properties:
 *  submitListHandler: emits when a security list is selected.
 */
export class SecurityAndListAutocompleteInPlaceComponent extends AutocompleteInPlaceDirective {
    constructor(changeDetector, securitiesService, securityListMenuService) {
        super(changeDetector);
        this.securitiesService = securitiesService;
        this.securityListMenuService = securityListMenuService;
        this.allowSecurityLists = true;
        this.securityListGroupOptions = DEFAULT_SECURITY_GROUP_TAB_OPTIONS;
        this.errorMessage = '';
        this.disableEditBtn = false;
        this.submitListHandler = new EventEmitter();
        this.shouldBlur = true;
    }
    blurHandler() {
        if (this.shouldBlur && this.displayIdentifier)
            this.cancel();
    }
    setDisplayValue() {
        if (this.securityListGroup) {
            this.securityListMenuService.getLabels().subscribe((labels) => {
                const displayValue = labels[this.securityListGroup][this.displayIdentifier];
                if (displayValue) {
                    this.displayValue = displayValue;
                    this.isEditing = false;
                }
                else {
                    this.reset();
                }
            });
        }
        else {
            this.securitiesService.getSecuritiesInfo(this.displayIdentifier).subscribe({
                next: (data) => {
                    this.displayValue = data[0]?.security_name;
                    this.isEditing = !this.displayValue;
                },
                error: () => {
                    // If no security with this symbol exists, reset the autocompleter
                    this.reset();
                },
            });
        }
    }
}
SecurityAndListAutocompleteInPlaceComponent.ɵfac = function SecurityAndListAutocompleteInPlaceComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SecurityAndListAutocompleteInPlaceComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.SecuritiesService), i0.ɵɵdirectiveInject(i2.SecurityListMenuService)); };
SecurityAndListAutocompleteInPlaceComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SecurityAndListAutocompleteInPlaceComponent, selectors: [["ycn-security-and-list-autocomplete-in-place"]], inputs: { allowSecurityLists: "allowSecurityLists", displayIdentifier: "displayIdentifier", securityListGroup: "securityListGroup", securityListGroupOptions: "securityListGroupOptions", errorMessage: "errorMessage", disableEditBtn: "disableEditBtn" }, outputs: { submitListHandler: "submitListHandler" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 14, vars: 20, consts: [["autocompleteComponent", ""], ["securityListSelectorModal", ""], [1, "form-group-editable", 3, "ngClass"], [1, "form-value"], ["class", "text-signal-orange-1", 3, "innerHTML", 4, "ngIf"], ["ycnTooltip", "", "ycnDisabled", "", 1, "btn", "btn-circle", "btn-transparent", "btn-edit", 3, "click", "disabled", "tooltipTitle"], ["ycnIcon", "", 3, "name"], [1, "input-group"], [1, "input-group", "field-input-group", 3, "blurHandler", "submitHandler", "appendToBody", "buttonType", "includeSearchIcon", "isDisabled", "placeholder", "searchType", "searchBlockRegex"], ["class", "input-group-btn", 4, "ngIf"], [3, "submitHandler", "activeSecurityGroupTab", "showSetOperations", "securityGroupTabOptions"], [1, "text-signal-orange-1", 3, "innerHTML"], [1, "input-group-btn"], ["href", "javascript:void(0)", 1, "btn", "btn-secondary", 3, "click", "hidden"], ["href", "javascript:void(0)", 1, "btn", "btn-secondary", 3, "mouseenter", "mouseleave", "click", "textContent"]], template: function SecurityAndListAutocompleteInPlaceComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div");
        i0.ɵɵtext(3);
        i0.ɵɵtemplate(4, SecurityAndListAutocompleteInPlaceComponent_div_4_Template, 1, 1, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵlistener("click", function SecurityAndListAutocompleteInPlaceComponent_Template_div_click_5_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.edit()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(6, "svg", 6);
        i0.ɵɵelementEnd()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(7, "div", 7)(8, "ycn-base-autocomplete", 8, 0);
        i0.ɵɵlistener("blurHandler", function SecurityAndListAutocompleteInPlaceComponent_Template_ycn_base_autocomplete_blurHandler_8_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.blurHandler()); })("submitHandler", function SecurityAndListAutocompleteInPlaceComponent_Template_ycn_base_autocomplete_submitHandler_8_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.submit($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, SecurityAndListAutocompleteInPlaceComponent_span_10_Template, 3, 1, "span", 9)(11, SecurityAndListAutocompleteInPlaceComponent_span_11_Template, 2, 1, "span", 9);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(12, "ycn-security-list-selector-modal", 10, 1);
        i0.ɵɵlistener("submitHandler", function SecurityAndListAutocompleteInPlaceComponent_Template_ycn_security_list_selector_modal_submitHandler_12_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.submitListHandler.emit($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c0, ctx.isEditing));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.displayValue, " ");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.errorMessage);
        i0.ɵɵadvance();
        i0.ɵɵproperty("disabled", ctx.disableEditBtn)("tooltipTitle", ctx.tooltipText);
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-edit");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("appendToBody", ctx.appendToBody)("buttonType", ctx.buttonType)("includeSearchIcon", false)("isDisabled", ctx.disableAutocompleterInput)("placeholder", ctx.placeholder)("searchType", ctx.searchType)("searchBlockRegex", ctx.searchBlockRegex);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.hideCancelButton);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.allowSecurityLists);
        i0.ɵɵadvance();
        i0.ɵɵproperty("activeSecurityGroupTab", "multi")("showSetOperations", false)("securityGroupTabOptions", ctx.securityListGroupOptions);
    } }, dependencies: [i3.BaseAutocompleteComponent, i4.DisabledDirective, i5.NgClass, i5.NgIf, i6.IconDirective, i7.TooltipDirective, i8.SecurityListSelectorModalComponent], encapsulation: 2 });
